__turbopack_context__.v({
  "dividers": "Stack-module__xuUmiG__dividers",
  "double": "Stack-module__xuUmiG__double",
  "half": "Stack-module__xuUmiG__half",
  "stack": "Stack-module__xuUmiG__stack",
});
